<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>账号</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="hideInAddRole = false">岗位</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInAddRole">
      <section class="searchBox">
        <span class="addStyle">
          <a-button
            type="primary"
            icon="plus"
            @click="hideInAddRole = !hideInAddRole"
            >增加</a-button
          >
        </span>
        <span class="searchStyle">
          <div>
            <label>身份:</label>
            <a-select
              defaultValue="全部"
              v-model="typeSearch"
              style="min-width:120px"
            >
              <a-select-option
                :value="item.value"
                v-for="(item, i) in typeList"
                :key="i"
                >{{ item.label }}</a-select-option
              >
            </a-select>
          </div>
          <div>
            <label style="width:100px;">岗位名称:</label>
            <a-input v-model="nameSearch" placeholder="请输入岗位名称" />
          </div>
          <div>
            <a-button type="primary" icon="search" @click="onSearch"
              >搜索</a-button
            >
          </div>
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <a-table
        :columns="columns"
        :dataSource="data"
        bordered
        :pagination="false"
        :loading="loading"
        :rowKey="record => record.id"
        class="tableStyle"
      >
        <template
          v-for="col in ['role_type', 'role_name', 'id']"
          :slot="col"
          slot-scope="text, record"
        >
          <div :key="col">
            <div v-if="record.editable">
              <a-input
                v-model="record.role_name"
                v-if="col == 'role_name'"
                :value="text"
                @change="e => handleChange(record.role_name, record.id, col)"
              />
              <a-select
                v-if="col == 'role_type'"
                :defaultValue="record.role_type"
                ref="selectTypes"
                v-model="record.role_type"
                @change="e => handleChange(record.role_type, record.id, col)"
              >
                <a-select-option
                  :value="item.value"
                  v-for="(item, i) in typeListTabel"
                  :key="i"
                  >{{ item.label }}</a-select-option
                >
              </a-select>
            </div>
            <template v-else>
              <p v-if="col == 'role_name'">{{ text }}</p>
              <p v-if="col == 'role_type'">
                <span v-show="text === 1">内部员工</span>
                <span v-show="text === 2">员工</span>
                <span v-show="text === 3">客户员工</span>
              </p>
            </template>
          </div>
        </template>
        <template slot="operation" slot-scope="text, record">
          <div class="editable-row-operations">
            <span class="delBtn">
              <a-popconfirm
                title="确定删除岗位吗？"
                okText="确定"
                cancelText="关闭"
                @confirm="() => onDelete(record.id)"
              >
                <a v-show="record.role_type != 1" href="javascript:;">删除</a>
              </a-popconfirm>
            </span>
            <span v-if="record.editable" class="editStyle">
              <a @click="() => save(record.id)">保存</a>
              <a-popconfirm
                title="确定取消？"
                okText="确定"
                cancelText="关闭"
                @confirm="() => cancel(record.id)"
              >
                <a>取消</a>
              </a-popconfirm>
            </span>
            <span v-else>
              <a v-show="record.role_type != 1" @click="() => edit(record.id)"
                >编辑</a
              >
            </span>
          </div>
        </template>
      </a-table>

      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>

    <!-- 增加 -->
    <addRole v-on:hideInAdd="hideInAdd" v-show="hideInAddRole" />
    <!-- 增加 end-->
  </div>
</template>
<script>
const columns = [
  {
    title: "岗位类型",
    dataIndex: "role_type",
    scopedSlots: { customRender: "role_type" }
  },
  {
    title: "岗位名称",
    dataIndex: "role_name",
    scopedSlots: { customRender: "role_name" }
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" }
  }
];
const data = [];
import axios from "axios";
import addRole from "@/components/account/addRole"; //增加岗位
import { mapState } from "vuex";
export default {
  components: {
    addRole
  },
  data() {
    this.cacheData = data.map(item => ({ ...item }));
    return {
      data,
      columns,
      loading: false,
      page: 1,
      pagination: {},
      typeList: [
        {
          label: "全部",
          value: -1
        },
        {
          label: "员工",
          value: 2
        },
        {
          label: "内部员工",
          value: 1
        },
        {
          label: "客户员工",
          value: 3
        }
      ],
      typeListTabel: [
        {
          label: "员工",
          value: 2
        },
        // {
        //   label: "内部员工",
        //   value: 1
        // },
        {
          label: "客户员工",
          value: 3
        }
      ],
      hideInAddRole: false,
      query_field: "",
      typeSearch: -1,
      totalPage: "",
      nameSearch: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    onChange(pageNumber) {
      // console.log("Page: ", pageNumber);
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddRole = msg;
      this.reload();
    },
    onSearch(value) {
      this.page = 1;
      this.getData();
    },
    getData() {
      this.loading = true;
      let url = this.httpsBasic.url + this.httpsBasic.user + "User/roleList";
      // console.log(url);
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.nameSearch,
          token: window.localStorage.getItem("xnwfPcToken"),
          role_type: this.typeSearch
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(key) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      // console.log(target);
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    },
    save(key) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        delete target.editable;
        this.data = newData;
        this.cacheData = newData.map(item => ({ ...item }));
      }
      let url = this.httpsBasic.url + this.httpsBasic.user + "User/editRole";
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken"),
        role_id: key,
        role_type: target.role_type,
        role_name: target.role_name
      };
      axios
        .post(url, pramas)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("提交成功");
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter(item => key === item.key)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    },
    onDelete(key) {
      const self = this;
      this.$confirm({
        title: "删除岗位?",
        content: "岗位一旦删除无法恢复，请谨慎操作!",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          let url =
            self.httpsBasic.url + self.httpsBasic.user + "User/deleteRole";
          axios
            .post(url, {
              token: window.localStorage.getItem("xnwfPcToken"),
              role_id: key
            })
            .then(res => {
              if (res.data.code == 200) {
                self.$message.success("删除成功");
              } else {
                self.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              self.$message.error("服务器出错啦...");
            });
        },
        onCancel() {}
      });
    }
  }
};
</script>
<style lang="less" scoped>
.listContainer {
  background: #fff;
  margin: 20px 2%;
  min-height: 80vh;
  .ant-table {
    min-height: 50vh;
  }
  .breadcrumb {
    padding: 14px 2% 10px;
  }
  .delBtn {
    margin-right: 10%;
    a {
      color: red;
    }
  }
  .editStyle {
    a {
      // margin-left: 6%;
    }
    a:last-child {
      color: #999;
    }
  }
  .breadcrumb {
    border-bottom: 1px solid #f0f2f5;
  }
  // 搜索
  // 搜索
  .searchBox {
    padding: 14px 2%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .searchStyle {
      display: inherit;
      // width: 40%;
      > div,
      > span {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-left: 20px;
        > label {
          margin-right: 6px;
          font-size: 14px;
        }
        input {
          display: inline-block;
        }
      }
    }
  }
  .addStyle .ant-btn-primary {
    background-color: #67c23a;
    border-color: #67c23a;
  }
  .tableStyle {
    padding: 0 2%;
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
